/**
 * Human-readable label for a project row (ED-2552).
 *
 * /projects/get-all does NOT put first_name/last_name on the project row —
 * the recipient's identity lives in the embedded `users` json array. Screens
 * that interpolated `p.first_name` directly rendered the literal
 * "undefined undefined" for any plan without an explicit project_name.
 * Same users/recipient derivation shape as recipientStateFromUsers.
 */

const recipientFromUsers = (p: any): any =>
  Array.isArray(p?.users)
    ? p.users.find((u: any) => u && u.cognito_id === p.recipient_cognito_id)
    : null;

export function projectLabel(p: any): string {
  if (!p) return 'Unknown';
  const explicit = typeof p.project_name === 'string' ? p.project_name.trim() : '';
  if (explicit) return explicit;
  const recipient = recipientFromUsers(p);
  // Top-level names still win as a fallback — some payloads (e.g. partner
  // customer summaries) do carry them on the row itself.
  const name = [recipient?.first_name ?? p.first_name, recipient?.last_name ?? p.last_name]
    .filter(Boolean)
    .join(' ')
    .trim();
  return name || 'Unknown';
}

/** Recipient's first name for possessive copy ("Zachary's"); '' when unknown. */
export function recipientFirstNameFromProject(p: any): string {
  const recipient = recipientFromUsers(p);
  const first = recipient?.first_name ?? p?.first_name;
  return typeof first === 'string' ? first.trim() : '';
}
